import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Dataset } from 'src/app/services/models/datasets.models';
import { DatasetFieldData } from './dataset-field-data.interface';

@Component({
  selector: 'bhub-dataset-field',
  templateUrl: './dataset-field.component.html',
  styleUrls: ['./dataset-field.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule]
})
export class DatasetFieldComponent {
  @Input() dataset!: Dataset;
  @Input() x: number = 0;
  @Input() y: number = 0;
  @Input() zIndex: number = 1;
  @Input() index: number = 0;
  @Input() fieldPositions: Map<string, {x: number, y: number, width: number, height: number}> = new Map();
  @Input() selectedFields: Set<string> = new Set();
  @Input() getConnectionType: (tableIndex: number, fieldName: string) => 'primary' | 'secondary' | 'base' | 'none' = () => 'none';

  @Output() dragStart = new EventEmitter<{event: DragEvent, index: number}>();
  @Output() remove = new EventEmitter<Dataset>();
  @Output() fieldClick = new EventEmitter<{tableIndex: number, fieldName: string}>();

  getDatasetColumns(dataset: Dataset) {
    return dataset.dataTableSchemas || [];
  }

  onDragStart(event: DragEvent) {
    this.dragStart.emit({ event, index: this.index });
  }

  onRemove() {
    this.remove.emit(this.dataset);
  }

  onFieldClick(fieldName: string) {
    this.fieldClick.emit({ tableIndex: this.index, fieldName });
  }

  getFieldData(fieldName: string, column: any): DatasetFieldData {
    if (fieldName === 'header') {
      return {
        x: 0,
        y: 0,
        width: 240,
        height: 30,
        fieldName: 'Field Name',
        dataType: 'Data Type',
        datasetId: 0,
        fieldId: 0,
        referenceDataId: 0,
        referenceFieldId: 0
      };
    }

    const fieldKey = `${this.index}_${fieldName}`;
    const fieldPos = this.fieldPositions.get(fieldKey);

    if (fieldPos) {
      return {
        x: fieldPos.x,
        y: fieldPos.y,
        width: fieldPos.width,
        height: fieldPos.height,
        fieldName: column.fieldName,
        dataType: column.dataType,
        datasetId: column.datasetId,
        fieldId: column.fieldId,
        referenceDataId: column.referenceDataId || 0,
        referenceFieldId: column.referenceFieldId || 0
      };
    }

    // Fallback if position not found
    return {
      x: 0,
      y: 0,
      width: 240,
      height: 25,
      fieldName: column.fieldName,
      dataType: column.dataType,
      datasetId: column.datasetId,
      fieldId: column.fieldId,
      referenceDataId: column.referenceDataId || 0,
      referenceFieldId: column.referenceFieldId || 0
    };
  }

  isFieldSelected(fieldName: string): boolean {
    const fieldKey = `${this.index}_${fieldName}`;
    return this.selectedFields.has(fieldKey);
  }

  getFieldConnectionType(fieldName: string): 'primary' | 'secondary' | 'base' | 'none' {
    return this.getConnectionType(this.index, fieldName);
  }
}
